import { BaseDataRecord } from '../types/report';

function escapeCsvCell(val: any): string {
  if (val === null || val === undefined) {
    return '';
  }
  const str = String(val);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function flattenReportDataToCsv(records: BaseDataRecord[]): string {
  if (!records || records.length === 0) {
    return '';
  }

  // Discover all Main column keys (excluding attandanceInfo)
  const mainKeysSet = new Set<string>();
  mainKeysSet.add('internalId');
  mainKeysSet.add('name');
  mainKeysSet.add('joiningDate');
  mainKeysSet.add('resignationDate');

  for (const emp of records) {
    for (const k of Object.keys(emp)) {
      if (k !== 'attandanceInfo' && k !== 'employeeUUID') {
        mainKeysSet.add(k);
      }
    }
  }
  const mainKeys = Array.from(mainKeysSet);

  // Discover all Details column keys
  const detailKeysSet = new Set<string>();
  detailKeysSet.add('Date');
  detailKeysSet.add('inTime');
  detailKeysSet.add('outTime');
  detailKeysSet.add('isLate');
  detailKeysSet.add('LateMinute');
  detailKeysSet.add('isAbsence');
  detailKeysSet.add('isOnLeave');
  detailKeysSet.add('LeaveType');
  detailKeysSet.add('PunchError');
  detailKeysSet.add('isPresentInHoliday');
  detailKeysSet.add('isHoliday');
  detailKeysSet.add('isWeeklyOff');
  detailKeysSet.add('shiftName');

  for (const emp of records) {
    if (emp.attandanceInfo) {
      for (const row of emp.attandanceInfo) {
        for (const k of Object.keys(row)) {
          detailKeysSet.add(k);
        }
      }
    }
  }
  const detailKeys = Array.from(detailKeysSet);

  // Header line
  const allHeaders = [...mainKeys, ...detailKeys];
  const rows: string[] = [allHeaders.map(escapeCsvCell).join(',')];

  // Data lines (1-to-N)
  for (const emp of records) {
    const mainValues = mainKeys.map((k) => emp[k]);

    if (!emp.attandanceInfo || emp.attandanceInfo.length === 0) {
      // Empty attendance row if employee was kept
      const emptyDetailValues = detailKeys.map(() => '');
      rows.push([...mainValues, ...emptyDetailValues].map(escapeCsvCell).join(','));
      continue;
    }

    for (const day of emp.attandanceInfo) {
      const detailValues = detailKeys.map((k) => day[k]);
      rows.push([...mainValues, ...detailValues].map(escapeCsvCell).join(','));
    }
  }

  return rows.join('\r\n');
}

export function downloadCsvFile(csvContent: string, filename: string) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy to clipboard', err);
    return false;
  }
}
